export const STRUCTURE_TAG_NAMES = {
  CONTENT: 'content',
  DESCRIPTION_TEXTAREA: 'description',
  ENDORSEMENT: 'endorsement',
  FREE_CONTENT: 'freeContent',
  FREE_PROMOTION: 'freePromotion',
  ORGANIZATION_ID: 'organizationID',
  STREAM_ID: 'streamID',
  CHANNEL_ID: 'channelID',
  RSS_FEED: 'rssFeed',
  PRICE: 'price',
  PRIORITY: 'priority',
  SUBSCRIPTION_NAME: 'subscriptionsName',
  SUBSCRIPTION_PRICE: 'price',
  SUBSCRIPTION_PRICE_VARIATION: 'priceVariation',
  MAX_AMOUNT: 'maxAmount',
  PROMOTION: 'promotion',
  INTERVAL: 'interval',
  OCCURRENCES: 'occurrences',
  QUANTITY: 'quantity',
  MIN_AMOUNT: 'minAmount',
  BOOST_AMOUNT: 'boostAmount',

  // use cases

  // store
  PRODUCT_ID: 'productId',
  CATEGORIES: 'categories',
  NAME: 'name',
  CALORIES: 'calories',
  SIZE: 'size',
  WEIGHT: 'weight',
  COOKING_TIME: 'cookingTime',
  INGREDIENTS: 'ingredients',
  DESCRIPTION: 'description',

  // job
  POSITION: 'position',
  CATEGORY: 'category',
  TASKS: 'tasks',
  DEPARTMENT: 'department',
  HIRING_MANAGER: 'hiringManager',
  BENEFITS: 'benefits',
  CLOSING: 'closing',
  CURRENCY: 'currency',
  SALARY: 'salary',
  MINIMUM_EDUCATIONS: 'minimumEducations',
  EDUCATION: 'education',
  WORK_EXPERIENCE: 'workExperience',
  COUNTRY: 'country',
  CITY: 'city',
  SKILLS: 'skills',
  SENIORITY: 'seniority',
  EMPLOYMENT_OPTIONS: 'employmentOptions',
  LANGUAGE: 'language',
  WORK_SCHEDULE: 'workSchedule',
  EMAIL: 'email',
  PHONE_NUMBER: 'phoneNumber',
};

export const STRUCTURE_TAG_PLACEHOLDERS = {
  OPTIONAL: 'optional',
  REQUIRED: 'required',
  PRIORITY_OPTIONAL: 'priorityOptional',
  PRICE: 'price',
  CURRENCY: 'currency',
  DURATION: 'duration',
  ZERO: 'zero',
  DISCOUNT: 'discount',
  X_OF_SUB: 'xOfSub',
  DESCRIPTION: 'description',
  POINTS: 'points',
  NO_SELECTED: 'noSelected',
};
